<div class="overlay">
  <div class="loader-content">
    <div class="loader-status" role="status" aria-live="polite" aria-busy="true">
      <div class="loader-mark" aria-hidden="true">
        <span class="dot dot-01"></span>
        <span class="dot dot-02"></span>
        <span class="dot dot-03"></span>
        <span class="dot dot-04"></span>
        <span class="dot dot-05"></span>
        <span class="dot dot-06 dot-seed"></span>
        <span class="dot dot-07"></span>
        <span class="dot dot-08"></span>
        <span class="dot dot-09"></span>
        <span class="dot dot-10"></span>
        <span class="dot dot-11"></span>
        <span class="dot dot-12"></span>
        <span class="dot dot-13"></span>
        <span class="dot dot-14"></span>
      </div>
      <div *ngIf="title" class="caption">
        <h1>{{ title }}</h1>
        <p>{{ message }}</p>
      </div>
      <div class="track" role="progressbar" aria-label="Loading"></div>
    </div>
  </div>
</div>
